import { useEffect } from 'react';

// Import theme.json directly
const theme = {
  variant: 'professional',
  primary: 'hsl(240 100% 20%)',
  radius: 0.75
};

interface ShadcnThemeProviderProps {
  children: React.ReactNode;
}

export function ShadcnThemeProvider({ children }: ShadcnThemeProviderProps) {
  useEffect(() => {
    if (typeof window === 'undefined') return;

    // Apply theme variables to the document root
    const root = document.documentElement;

    // Set primary color
    const primaryHsl = theme.primary.match(/hsl\(([^)]+)\)/)?.[1];
    if (primaryHsl) {
      root.style.setProperty('--primary', primaryHsl);
    }

    // Set border radius
    if (theme.radius) {
      root.style.setProperty('--radius', `${theme.radius}rem`);
    }
  }, []);

  return <>{children}</>;
}
